export const CREATE_DYNAMIC_ACC = "CREATE_DYNAMIC_ACC";
export const CREATE_DYNAMIC_ACC_SUCCESS = "CREATE_DYNAMIC_ACC_SUCCESS";
export const CREATE_DYNAMIC_ACC_ERROR = "CREATE_DYNAMIC_ACC_ERROR";